


























import { computed, defineComponent, ref } from "@vue/composition-api";
import SwiperClass, { SwiperOptions } from "swiper";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { StoryFeed } from "@/types";
import BaseImage from "@/components/BaseImage";

export default defineComponent({
  name: "StoriesStatisticPreviews",
  components: {
    BaseImage,
    Swiper,
    SwiperSlide,
  },
  props: {
    stories: { type: Array as () => StoryFeed[], required: true },
    value: { type: String },
  },
  setup(props, { emit }) {
    const currentItem = ref(props.stories.findIndex(s => s.id === props.value) ?? 0);
    const swiperOptions = ref<SwiperOptions>({
      slidesPerView: "auto",
      centeredSlides: true,
      slideToClickedSlide: true,
      initialSlide: currentItem.value,
      height: 178,
      slideActiveClass: "stories-statistic-previews__swiper-slide-active",
    });
    const swiperComponentRef = ref<any>(null);
    const swiperComponentInstance = computed(() => swiperComponentRef.value?.$swiper as SwiperClass);

    const onSlideChange = () => {
      emit("input", props.stories[swiperComponentInstance.value.activeIndex].id);
      currentItem.value = swiperComponentInstance.value.activeIndex;
      if (currentItem.value === props.stories.length - 1) emit("next");
    };

    const getImageSrc = (story: StoryFeed) =>
      isVideoFile(story.files[0])
        ? MediaFilesController.getVideoThumbnail(story.files[0].urlPart, "360p")
        : MediaFilesController.getImageThumbnail(story.files[0].urlPart, "360p");

    const getOverlaySrc = (story: StoryFeed) =>
      (!!story.overlay && MediaFilesController.getFileUrl(story.overlay.urlPart)) || "";

    return {
      swiperOptions,
      swiperComponentRef,
      onSlideChange,
      getImageSrc,
      getOverlaySrc,
    };
  },
});
